import { InsurersCodeEnum } from '../../../enums/insurers-code.enum';
import { InsurerState } from '../../../types/InsurerState';

const PORTO_VARIANT_CODES = [
  InsurersCodeEnum.PortoEssencial,
  InsurersCodeEnum.Porto12,
  InsurersCodeEnum.Porto18,
  InsurersCodeEnum.Porto20,
  InsurersCodeEnum.Porto30
];

export type ClaimInsurerDropdownOption = {
  index: string | number;
  value: string;
  text: string;
};

export function getClaimInsurerDropdownOptions(
  insurers: InsurerState[] | null | undefined
): ClaimInsurerDropdownOption[] {
  if (!insurers?.length) return [];

  return insurers
    .filter(insurer => !PORTO_VARIANT_CODES.includes(insurer.code as InsurersCodeEnum))
    .map(insurer => ({
      index: insurer.id,
      value: insurer.id,
      text: insurer.name
    }));
}
